module.exports = __webpack_public_path__ + "static/media/tickCircle.ef8ffb5e.svg";